<!-- 生日礼-领取成功：Figma「领取成功」20:538 -->
<template>
  <div class="claim-success-page">
    <div class="claim-success-inner">
      <div class="claim-success-hero">
        <div class="claim-success-ellipse" aria-hidden="true" />
        <img class="claim-success-mascot" :src="mascotImg" alt="" />
      </div>
      <h1 class="claim-success-title">领取成功</h1>
      <p class="claim-success-sub">请前往「微信卡包」查看你的立减金</p>

      <div class="claim-success-prize-card">
        <img class="claim-success-coupon-img" :src="couponImg" alt="" />
        <div class="claim-success-prize-text">
          <p class="claim-success-prize-name">{{ displayRightsName }}</p>
          <p class="claim-success-valid">{{ validLine }}</p>
        </div>
      </div>

      <div class="claim-success-tips-card">
        <h2 class="claim-success-tips-h">· 温馨提示 ·</h2>
        <p class="claim-success-tips-p">
          1、微信立减金领取后10天有效，有效期以微信卡包显示为准，过期不补。
        </p>
        <p class="claim-success-tips-p">
          2、使用厦门国际银行借记卡进行微信支付满足立减金消费门槛自动抵扣，具体使用范围以实际抵扣为准。
        </p>
        <p class="claim-success-tips-p">
          3、享受优惠的订单，如发生全额退款，且立减金仍在有效期内，立减金将自动退还给用户。如发生部分退款，用户支付金额将按比例原路退还，立减金将按比例退还给用户，用户可继续使用。如立减金已过期，则不退还给用户。
        </p>
        <p class="claim-success-tips-p">
          4、立减金仅限商业支付时使用，社交支付（如转账、红包、个人收款码支付等）不可用。不可使用商户：肯德基、必胜客、CoCo奶茶、Five
          Plus、Miss
          Sixty、ochirly、CovenGarden、Denham、孩子王、热风、太平鸟、优衣库、广东电信、星巴克、珠海城建、航联、微众银行、分付、零钱通、理财通、信用卡还款、腾安基金、哔哩哔哩、华为商城、北京市医院管理中心等。合单支付（微信支付订单号为44开头的交易）无法使用立减金；中国境外商户无法使用立减金。
        </p>
        <p class="claim-success-tips-p">
          5、本券不找零，不可兑换为现金，不可转让，优惠金额部分不开具发票。
        </p>
        <p class="claim-success-tips-p">
          6、同一微信号、同一手机号、同一身份证号、同一设备号等，符合其中任意条件视为同一用户。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { wxApiEmpower, isWechat } from "@/utils/common";

export default {
  name: "SuccessResultPage",
  data() {
    return {
      mascotImg: require("@/assets/imgs/xiamenBirthdayGift/claim-success-mascot.png"),
      couponImg: require("@/assets/imgs/xiamenBirthdayGift/claim-success-coupon.png"),
    };
  },
  computed: {
    displayRightsName() {
      const q = this.$route.query.rightsName;
      if (q == null || String(q).trim() === "") return "—";
      return String(q);
    },
    validLine() {
      const q = this.$route.query;
      const v = q.availableEndTime;
      if (v != null && String(v).trim() !== "") {
        return `有效期至：${String(v).trim()}`;
      }
      return "有效期以微信卡包显示为准";
    },
  },
  mounted() {
    this.hideShare();
  },
  methods: {
    hideShare() {
      if (!isWechat()) return;
      wxApiEmpower().then(() => {
        // eslint-disable-next-line no-undef
        wx.hideAllNonBaseMenuItem({
          success() {},
          fail(res) {
            console.log(res, "禁止分享-设置失败");
          },
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.claim-success-page {
  min-height: 100vh;
  box-sizing: border-box;
  background: linear-gradient(180deg, #7ab5e8 0%, #f4f4d4 100%);
  padding: 34px 15px 40px;
}

.claim-success-inner {
  max-width: 345px;
  margin: 0 auto;
}

.claim-success-hero {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 90px;
  margin-bottom: 10px;
}

.claim-success-ellipse {
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 74px;
  height: 74px;
  margin-left: -37px;
  border-radius: 50%;
  background: linear-gradient(
    180deg,
    rgba(255, 253, 245, 0.8) 0%,
    rgba(202, 223, 228, 0.5) 100%
  );
}

.claim-success-mascot {
  position: relative;
  z-index: 1;
  display: block;
  width: 74px;
  height: 90px;
  object-fit: contain;
}

.claim-success-title {
  margin: 0 0 8px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  color: #000000;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.claim-success-sub {
  margin: 0 0 24px;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  line-height: 15px;
  color: #667387;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.claim-success-prize-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  min-height: 110px;
  padding: 20px 16px;
  padding-right: 0;
  margin-bottom: 10px;
  border-radius: 15px;
  background: #ffffff;
}

.claim-success-coupon-img {
  flex-shrink: 0;
  width: 110px;
  height: 72px;
  object-fit: cover;
  border-radius: 8px;
}

.claim-success-prize-text {
  flex: 1;
  min-width: 0;
  padding-left: 12px;
  text-align: left;
}

.claim-success-prize-name {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.3;
  color: #000000;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  word-break: break-word;
}

.claim-success-valid {
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 15px;
  color: #667387;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  word-break: break-word;
}

.claim-success-tips-card {
  box-sizing: border-box;
  width: 100%;
  padding: 20px 22px 24px;
  border-radius: 15px;
  background: #ffffff;
}

.claim-success-tips-h {
  margin: 0 0 16px;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.2;
  color: #000000;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.claim-success-tips-p {
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: #667387;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
